import React from "react";
import {
  SEO,
  PageLayout,
  Section,
  DynamicTiles,
  MultipleComponentIterator,
  FishermanHeader,
  MarkdownContent,
  WebsiteComponentInteractions,
  SlideReveal,
  FullImageCard,
  InternalLink,
  FishermanIcon,
  FadeReveal,
  BasicCarousel,
  componentIterator,
  Image,
  ScrollableContent,
  div,
  SocialMediaV2,
  Location,
  Email,
  Phone,
  HoursOfOperation,
  ContinuousScrollV2,
  multipleComponentIterator,
  TeamMemberV2,
} from "@bluefin/components";
import { Button, Grid, Card } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
  getComponentInteractions,
} from "../utils/utils";
import { createTeamMemberSlug } from "@bluefin/gatsby-plugin-fisherman-page-creator";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      dynamicTilesComponent,
      allFishermanBusinessTeam,
      allFishermanBusinessLocation,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          title={fishermanBusinessWebsitePage.seoTitle}
          ogUrl={""}
        />
        <PageLayout hero={false} subfooter={false} className={"home-page"}>
          <Section className={"custom-hero-section"}>
            <DynamicTiles className={"custom-hero"}>
              <MultipleComponentIterator
                iterator={dynamicTilesComponent.childConfigurations}
                components={[
                  {
                    component: (
                      <DynamicTiles.Tile
                        imageProps={{ loadStrategy: "eager" }}
                      />
                    ),
                    propMap: {
                      images: "files",
                      content: "contentNodes",
                      interactions: "interactions",
                      className: "data.className",
                      overlayClassName: "data.overlayClassName",
                      width: "data.width",
                      video: "data.video",
                    },
                  },
                ]}
              />
            </DynamicTiles>
          </Section>
          <Section className={"services-section"}>
            <FishermanHeader
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_header",
                defaultValue: "Our Services",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
            />
            <WebsiteComponentInteractions
              ctas={getComponentInteractions({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
              alignment={"center"}
            />
            <Card.Group itemsPerRow={4}>
              <SlideReveal
                className={"ui card"}
                direction={"up"}
                triggerOnce={true}
                fade={true}
                key={"1"}
              >
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://fisherman.gumlet.io/public/fcf71f18-b3ed-46b6-81d6-ab51205b5141/Screenshot_20250815_141137_Instagram.jpg"
                  }
                  to={
                    "https://sites.gofisherman.com/aboveallgrandsalonspa/services/haircuts-styling/"
                  }
                  label={"Haircuts & Styling"}
                >
                  <Card.Header>
                    <span>Haircuts & Styling</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Our talented stylists provide expert haircuts and styling services tailored to complement your features and lifestyle. From classic cuts to modern trends, we'll create a look that makes you feel confident and beautiful."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://fisherman.gumlet.io/public/fcf71f18-b3ed-46b6-81d6-ab51205b5141/1000046897.jpg"
                  }
                  to={
                    "https://sites.gofisherman.com/aboveallgrandsalonspa/services/hair-color/"
                  }
                  label={"Hair Color"}
                >
                  <Card.Header>
                    <span>Hair Color</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Our color services transform your look with expert techniques ranging from subtle highlights to bold, all-over transformations that enhance your natural beauty and personal style."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://fisherman.gumlet.io/public/fcf71f18-b3ed-46b6-81d6-ab51205b5141/DSC07259_1_DGbb5LK.jpeg"
                  }
                  to={
                    "https://sites.gofisherman.com/aboveallgrandsalonspa/services/hair-extensions/"
                  }
                  label={"Hair Extensions"}
                >
                  <Card.Header>
                    <span>Hair Extensions</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Our hair extension services add beautiful length, volume, and versatility to your look with expert application techniques tailored to blend seamlessly with your natural hair. Transform your style with luxurious extensions that feel as good as they look."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://fisherman.gumlet.io/public/fcf71f18-b3ed-46b6-81d6-ab51205b5141/giorgio-trovato-ldC8xP2Z9lo-unsplash.jpg?width=500"
                  }
                  to={
                    "https://sites.gofisherman.com/aboveallgrandsalonspa/services/hair-treatments/"
                  }
                  label={"Hair Treatments"}
                >
                  <Card.Header>
                    <span>Hair Treatments</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Our specialized treatments target your specific hair and scalp needs, from deep conditioning and keratin smoothing to revitalizing masks and intensive repair therapies. Each treatment is carefully selected to restore, strengthen, and enhance your hair's natural beauty and health."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://fisherman.gumlet.io/public/fcf71f18-b3ed-46b6-81d6-ab51205b5141/5_vqm7YQh.png"
                  }
                  to={
                    "https://sites.gofisherman.com/aboveallgrandsalonspa/services/facial-treatments/"
                  }
                  label={"Facial Treatments"}
                >
                  <Card.Header>
                    <span>Facial Treatments</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Our facial treatments are designed to rejuvenate and nourish your skin, leaving you with a healthy, radiant glow. Each service is customized to address your unique skin concerns and goals."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://fisherman.gumlet.io/public/fcf71f18-b3ed-46b6-81d6-ab51205b5141/5_37tVxNG.png"
                  }
                  to={
                    "https://sites.gofisherman.com/aboveallgrandsalonspa/services/brows-and-lashes/"
                  }
                  label={"Brows and Lashes"}
                >
                  <Card.Header>
                    <span>Brows and Lashes</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Our Brows and Lashes services enhance your natural beauty with expert shaping, tinting, and extensions. From precise brow sculpting to luxurious lash lifts, we create a polished, eye-catching look tailored to you."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://fisherman.gumlet.io/public/fcf71f18-b3ed-46b6-81d6-ab51205b5141/Waxing.png"
                  }
                  to={
                    "https://sites.gofisherman.com/aboveallgrandsalonspa/services/waxing/"
                  }
                  label={"Waxing"}
                >
                  <Card.Header>
                    <span>Waxing</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Our expert waxing services deliver smooth, long-lasting hair removal for the body and face using professional techniques that prioritize your comfort. Leave with silky skin that stays beautiful for weeks."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://fisherman.gumlet.io/public/fcf71f18-b3ed-46b6-81d6-ab51205b5141/8_2tA0CWb.png"
                  }
                  to={
                    "https://sites.gofisherman.com/aboveallgrandsalonspa/services/massage/"
                  }
                  label={"Massage"}
                >
                  <Card.Header>
                    <span>Massage</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Enjoy relaxation and recovery with our physical therapy massage at Above All Grand Salon and Spa. Our massage therapy helps relieve muscle tension, improve movement, and boost overall well-being. Whether you’re healing from an injury or need to unwind, our skilled therapists will customize your session to fit your needs. Discover how our massage therapy can help you feel better and live healthier."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
              </SlideReveal>
            </Card.Group>
            <div className={"see-all-services-container"}>
              <Button
                primary={true}
                event={{ category: "Services", action: "View All Services" }}
                as={InternalLink}
                to={"/services/"}
              >
                <span
                  children={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "see_all_services_button",
                    defaultValue: "Discover More Services",
                  })}
                />
              </Button>
            </div>
          </Section>
          <Section className={"about-section"}>
            <Grid stackable={true}>
              <Grid.Column width={8}>
                <FadeReveal duration={1250} triggerOnce={true} delay={0}>
                  <div>
                    <FishermanHeader
                      as={"h2"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_header",
                        defaultValue: "About Us",
                      })}
                    />
                    <FishermanHeader
                      as={"h3"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_subheader",
                      })}
                    />
                    <MarkdownContent
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_description",
                      })}
                    />
                    <WebsiteComponentInteractions
                      ctas={getComponentInteractions({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_description",
                      })}
                      fallback={
                        <React.Fragment>
                          <Button
                            primary={true}
                            to={"/about/"}
                            as={InternalLink}
                            content={getComponentContentNodeContent({
                              components:
                                fishermanBusinessWebsitePage.components,
                              componentId: "see_more_about_button",
                              defaultValue: "Learn More About Us",
                            })}
                            event={{ category: "About", action: "View About" }}
                          />
                        </React.Fragment>
                      }
                    />
                  </div>
                </FadeReveal>
              </Grid.Column>
              <Grid.Column width={8}>
                <FadeReveal duration={1250} triggerOnce={true} delay={450}>
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={componentIterator({
                      iterator: getComponentFiles({
                        components: fishermanBusinessWebsitePage.components,
                        componentName: "ImageCollection",
                        componentIdentifier: "about_section_images",
                      }),
                      component: (
                        <Image
                          background={true}
                          className={"single-item-carousel-image"}
                        />
                      ),
                      propMap: { src: "__all__" },
                    })}
                  />
                </FadeReveal>
              </Grid.Column>
            </Grid>
          </Section>
          <Section className={"team-section"}>
            <ScrollableContent
              direction={"horizontal"}
              distanceFactor={"snap"}
              intervalFactor={500}
            >
              <Grid stackable={true} columns={2}>
                <Grid.Column className={"content-column"} width={4}>
                  <FishermanHeader
                    as={"h2"}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "staff_section_header",
                      defaultValue: "Our Team",
                    })}
                  />
                  <FishermanHeader
                    as={"h3"}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "staff_section_subheader",
                      defaultValue: "Boost Your True Beauty",
                    })}
                  />
                  <MarkdownContent
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "staff_section_description",
                    })}
                  />
                  <WebsiteComponentInteractions
                    ctas={getComponentInteractions({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "staff_section_description",
                    })}
                    fallback={
                      <React.Fragment>
                        <Button
                          as={InternalLink}
                          to={"/team/"}
                          primary={true}
                          content={getComponentContentNodeContent({
                            components: fishermanBusinessWebsitePage.components,
                            componentId: "see_all_team_button",
                            defaultValue: "See Our Team",
                          })}
                          className={"see-more-button"}
                          event={{
                            category: "Team",
                            action: "View All Team Members",
                          }}
                        />
                      </React.Fragment>
                    }
                  />
                  <div className={"triggers-container"}>
                    <ScrollableContent.PreviousTrigger />
                    <ScrollableContent.NextTrigger />
                  </div>
                </Grid.Column>
                <Grid.Column className={"team-member-cards-column"} width={12}>
                  <ScrollableContent.Content hideScrollbar={true}>
                    <MultipleComponentIterator
                      iterator={allFishermanBusinessTeam.nodes}
                      components={[
                        {
                          component: (
                            <FadeReveal
                              className={"ui card"}
                              triggerOnce={true}
                            />
                          ),
                          propMap: { key: "_id" },
                          children: [
                            {
                              component: (
                                <FullImageCard
                                  link={true}
                                  className={"team-member-card"}
                                  as={InternalLink}
                                  event={{
                                    category: "Team",
                                    action: "View Team Member",
                                  }}
                                />
                              ),
                              propMap: {
                                key: "_id",
                                image: "gatsbyImage",
                                to: createTeamMemberSlug,
                              },
                              children: [
                                {
                                  component: <TeamMemberV2.Name />,
                                  propMap: { name: "name" },
                                },
                                {
                                  component: <TeamMemberV2.Role />,
                                  propMap: { role: "role" },
                                },
                              ],
                            },
                          ],
                        },
                      ]}
                    />
                  </ScrollableContent.Content>
                  <div className={"actions-container"}>
                    <WebsiteComponentInteractions
                      ctas={getComponentInteractions({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "staff_section_description",
                      })}
                      fallback={
                        <React.Fragment>
                          <Button
                            as={InternalLink}
                            to={"/team/"}
                            content={getComponentContentNodeContent({
                              components:
                                fishermanBusinessWebsitePage.components,
                              componentId: "see_all_team_button",
                              defaultValue: "See Our Team",
                            })}
                            className={"see-more-button"}
                            primary={true}
                          />
                        </React.Fragment>
                      }
                    />
                    <div className={"triggers-container"}>
                      <ScrollableContent.PreviousTrigger />
                      <ScrollableContent.NextTrigger />
                    </div>
                  </div>
                </Grid.Column>
              </Grid>
            </ScrollableContent>
          </Section>
          <div className={"ig-social-media-section"}>
            <div className={"header-container"}>
              <FishermanHeader
                as={"h3"}
                content={"Follow Us On Social Media"}
              />
            </div>
            <SocialMediaV2>
              <MultipleComponentIterator
                iterator={fishermanBusiness.socialMedia}
                components={[
                  {
                    component: <SocialMediaV2.Platform />,
                    propMap: { key: "_id", url: "link", platform: "type" },
                    children: [
                      {
                        component: <SocialMediaV2.Icon />,
                        propMap: { icon: "type" },
                      },
                    ],
                  },
                ]}
              />
            </SocialMediaV2>
            <div
              className={"elfsight-app-bb0664f2-e06a-469d-be2f-6269df6e5ade"}
              data-elfsight-app-lazy={true}
            />
          </div>
          <Section className={"locations-section"}>
            <Grid columns={2} stackable={true}>
              <Grid.Column width={8} className={"carousel-column"}>
                <FadeReveal duration={1250} triggerOnce={true} delay={0}>
                  <BasicCarousel
                    className={"locations-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={false}
                    autoScroll={false}
                    mobile={{ size: 1 }}
                    items={componentIterator({
                      iterator: getComponentFiles({
                        components: fishermanBusinessWebsitePage.components,
                        componentName: "ImageCollection",
                        componentIdentifier: "locations_section_images",
                      }),
                      component: (
                        <Image
                          background={true}
                          className={"single-item-carousel-image"}
                        />
                      ),
                      propMap: { src: "__all__" },
                    })}
                  />
                </FadeReveal>
              </Grid.Column>
              <Grid.Column width={8} className={"information-column"}>
                <FadeReveal duration={1250} triggerOnce={true} delay={450}>
                  <div className={"information-content"}>
                    <FishermanHeader
                      as={"h2"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "locations_section_header",
                      })}
                    />
                    <FishermanHeader
                      as={"h3"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "locations_section_subheader",
                      })}
                    />
                    <MarkdownContent
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "locations_section_description",
                      })}
                    />
                    <WebsiteComponentInteractions
                      ctas={getComponentInteractions({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "locations_section_description",
                      })}
                      fallback={
                        <React.Fragment>
                          <Button
                            primary={true}
                            as={InternalLink}
                            to={"/contact/"}
                            content={"Contact Us"}
                          />
                        </React.Fragment>
                      }
                    />
                  </div>
                  <Card.Group className={"locations-cards"}>
                    <MultipleComponentIterator
                      iterator={allFishermanBusinessLocation.nodes}
                      components={[
                        {
                          component: <Card />,
                          propMap: { key: "_id" },
                          children: [
                            {
                              component: <Card.Content />,
                              children: [
                                {
                                  component: <Card.Header />,
                                  propMap: { content: "name" },
                                },
                                {
                                  component: <Card.Description />,
                                  children: [
                                    {
                                      component: <Location inline={true} />,
                                      propMap: {
                                        "address.street": "street",
                                        "address.city": "city",
                                        "address.state": "state",
                                        "address.zip": "zipCode",
                                      },
                                    },
                                    {
                                      component: <Email />,
                                      propMap: { email: "email" },
                                    },
                                    {
                                      component: <Phone />,
                                      propMap: { phone: "phoneNumber" },
                                    },
                                  ],
                                },
                                {
                                  component: (
                                    <HoursOfOperation
                                      displayOption={"dailyWithPopup"}
                                    />
                                  ),
                                  propMap: { hours: "hours" },
                                },
                              ],
                            },
                          ],
                        },
                      ]}
                    />
                  </Card.Group>
                </FadeReveal>
              </Grid.Column>
            </Grid>
          </Section>
          <Section className={"trusted-by-section"}>
            <div className={"content-container"}>
              <FishermanHeader
                as={"h2"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "trusted_by_section_header",
                })}
              />
              <MarkdownContent
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "trusted_by_section_description",
                })}
              />
              <WebsiteComponentInteractions
                ctas={getComponentInteractions({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "trusted_by_section_description",
                })}
              />
            </div>
            <ContinuousScrollV2
              loadStrategy={"inViewport"}
              sizePatterns={[{ width: 100, height: 50, alignment: "middle" }]}
              items={multipleComponentIterator({
                iterator: getComponentFiles({
                  components: fishermanBusinessWebsitePage.components,
                  componentName: "ImageCollection",
                  componentIdentifier: "trusted_by_images",
                }),
                components: [
                  {
                    component: <ContinuousScrollV2.Item />,
                    propMap: { key: "_id" },
                    children: [
                      {
                        component: <Image loadStrategy={"eager"} />,
                        propMap: { src: "__all__" },
                      },
                    ],
                  },
                ],
              })}
            />
          </Section>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      socialMedia {
        _id
        link
        type
      }
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
          _id
        }
        contentNodes {
          content
        }
        interactions {
          _id
          order
          behaviorType
          displayType
          enabled
          label
          style
          url
          role
        }
      }
      seoTitle
    }
    dynamicTilesComponent: fishermanWebsiteComponent(
      page: { pageType: { eq: "Home" } }
      fastId: { eq: "DynamicTiles" }
    ) {
      childConfigurations {
        data {
          className
          overlayClassName
          width
          video {
            videoId
            url
            source
            placeholder
          }
        }
        files {
          _id
          altText
          file
          order
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        contentNodes {
          _id
          content
          contentType
          contentName
          order
        }
        interactions {
          _id
          displayType
          behaviorType
          enabled
          label
          order
          style
          url
        }
      }
    }
    allFishermanBusinessTeam(
      sort: { order: ASC, fields: order }
      filter: { show: { eq: true } }
    ) {
      nodes {
        _id
        name
        role
        group
        email
        phone
        description
        image
        gatsbyImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        socialMedia {
          platform
          url
        }
        hours {
          startDay
          openTime
          closeTime
        }
        locations {
          _id
          name
        }
        show
      }
    }
    allFishermanBusinessLocation {
      nodes {
        _id
        street
        city
        state
        zipCode
        name
        phoneNumber
        email
        hours {
          open
          close
          day
          label
        }
      }
    }
  }
`;
